export default __webpack_public_path__ + "static/media/gallery_00.aa7bec49.jpg";